<template>
  <div class="social-links" itemscope itemtype="http://schema.org/Organization">
    <link itemprop="url" href="http://querobolsa.com.br">
    <a itemprop="sameAs" href="https://www.youtube.com/querobolsa" target="_blank" rel="noopener noreferrer">
      <font-awesome-icon :icon="['fab', 'youtube']" class="social-links__icon" size='2x' />
    </a>
    <a itemprop="sameAs" href="https://www.instagram.com/querobolsa/" target="_blank" rel="noopener noreferrer">
      <font-awesome-icon :icon="['fab', 'instagram']" class="social-links__icon" size='2x' />
    </a>
    <a itemprop="sameAs" href="https://www.facebook.com/QueroBolsa/" target="_blank" rel="noopener noreferrer">
      <font-awesome-icon :icon="['fab', 'facebook-f']" class="social-links__icon" size='2x' />
      <span class="social-links__likes">821k likes</span>
    </a>
  </div>
</template>

<style lang="sass" scoped>
  @import '~/assets/stylesheets/utils/module.sass'

  .social-links
    align-items: center
    display: flex
    justify-content: center
    padding: 11px 0px
    text-align: center

    a
      color: $footer-color
      align-items: center
      display: flex
      justify-content: center
      margin-right: $space-m

      span
        margin-top: $space-xs

      &:hover
        text-decoration: none

    @media (min-width: $screen-md-min)
      justify-content: flex-start
      margin-right: -19px
      text-align: right

    @media (min-width: $screen-lg-min)
      margin: 0
      padding: 0
      text-align: left

  .social-links__icon
    height: 35px
    margin: 0 19px

    @media (min-width: $screen-lg-min)
      margin: 0 $space-s 0 0

  .social-links__likes
    color: $footer-color
    display: none

    @media (min-width: $screen-lg-min)
      display: inline
      font-size: rem(13)
      padding-left: $space-xs

      &:hover
        text-decoration: none

</style>

<script>
  import { library } from '@fortawesome/fontawesome-svg-core';
  import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
  import { fab } from '@fortawesome/free-brands-svg-icons'
  import { faFacebookF, faInstagram, faYoutube } from '@fortawesome/free-brands-svg-icons';

  library.add(fab, faFacebookF, faInstagram, faYoutube);

  export default {
    data() {
      return {}
    },
    components: {
      FontAwesomeIcon,
    }
  }
</script>
